<template>
  <InvoiceParameterDefaultModal
    title="Regras localizadas"
    width="840"
    showOctagon
    disableBodyPadding
    :show="show"
    @close="closeConflictingRuleFoundModal">
    <template slot="icon">
    </template>
    <template slot="body">
      <div>
        <div style="padding: 20px 20px 0;">
          <span class="foreground--text">
            Foram localizadas regras de acordo com o filtro aplicado.
            Você pode editar uma existente, criar uma nova ou fechar essa ação.
          </span>
        </div>
        <v-divider class="my-4"/>
      </div>
      <v-data-table
        class="invoice-parameter-table"
        hide-default-footer
        mobile-breakpoint="0"
        style="max-height: 550px;"
        :headers="headers"
        :items="conflictingRuleList"
        :items-per-page="-1">
        <template
          v-slot:[`header.type`]>
          <Header>Tipo de Nível</Header>
        </template>
        <template
          v-slot:[`header.entity`]>
          <Header>Opção do Nível</Header>
        </template>
        <template
          v-slot:[`header.rule`]>
          <Header>Regra</Header>
        </template>
        <template
          v-slot:[`header.description`]>
          <Header>Descrição</Header>
        </template>
        <template
          v-slot:[`header.value`]>
          <Header>Valor</Header>
        </template>
        <template
          v-slot:[`header.status`]>
          <Header>Status</Header>
        </template>

        <template
          v-slot:[`item.type`]="{ item }">
          <TableBody>
            {{ getEntityLevelName(item.entityLevel) }}
          </TableBody>
        </template>
        <template
          v-slot:[`item.entity`]="{ item }">
          <TableBody>
            {{ item.entityLevelName }}
          </TableBody>
        </template>
        <template
          v-slot:[`item.rule`]="{ item }">
          <TableBody>
            {{ item.name }}
          </TableBody>
        </template>
        <template
          v-slot:[`item.description`]="{ item }">
          <TableBody>
            {{ item.description }}
          </TableBody>
        </template>
        <template
          v-slot:[`item.value`]="{ item }">
          <TableBody
            v-if="!isList(item.valueType)">
            {{ convertText(getConfigValue(item.value, item.valueType)) }}
          </TableBody>
          <div
            class="d-flex flex-row align-center"
            v-if="isList(item.valueType)">
            <v-chip>
              <TableBody textSm>
                {{ convertText(getConfigValue(item.value[0], item.valueType)) }}
              </TableBody>
            </v-chip>
            <v-tooltip
              bottom>
              <template v-slot:activator="{ on: onTab, attrs: attrsTab }">
                <span
                  v-on="onTab"
                  v-bind="attrsTab"
                  textSm
                  class="ml-2 foreground--text text-caption">
                  {{
                    formatter.getPluralText(
                      "outra",
                      item.value
                    )
                  }}
                </span>
              </template>
              <span>
                {{ getOptionsDescription(item.value, item.valueType) }}
              </span>
            </v-tooltip>
          </div>
        </template>
        <template
          v-slot:[`item.status`]="{ item }">
          <TableBody>
            {{ item.active ? 'Ativo' : 'Inativo' }}
          </TableBody>
        </template>
      </v-data-table>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-end gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          outlined
          @click="closeConflictingRuleFoundModal">
          Fechar
        </v-btn>
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="updateExistingRule">
          Editar Regra Existente
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import InvoiceParameterTableBody from '../components/InvoiceParameterTableBody.vue';
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterHeader from '../components/InvoiceParameterHeader.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: "ConflictingRuleFoundModal",
  components: {
    TableBody: InvoiceParameterTableBody,
    Header: InvoiceParameterHeader,
    TextBase: InvoiceParameterText,
    InvoiceParameterDefaultModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
  mixins: [
    InvoiceParametersMixin,
  ],
  methods: {
    ...mapActions({
      startUpdatingExistingConfigs: 'invoice-parameter/startUpdatingExistingConfigs',
    }),
    ...mapMutations({
      setShowConflictingRuleFoundModal: 'invoice-parameter/setShowConflictingRuleFoundModal',
      goToAdvanceRuleDetail: 'invoice-parameter/goToAdvanceRuleDetail',
    }),
    closeConflictingRuleFoundModal() {
      this.setShowConflictingRuleFoundModal(false);
    },
    async updateExistingRule() {
      await this.startUpdatingExistingConfigs();
      this.closeConflictingRuleFoundModal();
      this.goToAdvanceRuleDetail();
    },
  },
  computed: {
    ...mapGetters({
      conflictingRuleList: 'invoice-parameter/conflictingRuleList',
    }),
    headers() {
      return [
        { value: 'type', sortable: false, class: 'col-type', cellClass: 'col-type' },
        { value: 'entity', sortable: false, class: 'col-entity', cellClass: 'col-entity' },
        { value: 'rule', sortable: false, class: 'col-rule', cellClass: 'col-rule' },
        { value: 'description', sortable: false, class: 'col-description', cellClass: 'col-description' },
        { value: 'value', sortable: false, class: 'col-value', cellClass: 'col-value' },
        { value: 'status', sortable: false, class: 'col-modal-status', cellClass: 'col-modal-status' },
      ];
    },
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>